export default __webpack_public_path__ + "298a73650e285ed3d7fe2504369b3180.png";